
import React from 'react';
import { ServiceDefinition, Language } from '../../types';
import { TRANSLATIONS } from '../../constants';

interface ServicesGridProps {
  language: Language;
  filteredServices: ServiceDefinition[];
  isPro: boolean;
  onSelectService: (service: ServiceDefinition) => void;
}

const ServicesGrid: React.FC<ServicesGridProps> = ({ 
  language, filteredServices, isPro, onSelectService 
}) => {
  const t = TRANSLATIONS[language];

  return (
    <div className="flex-1 overflow-y-auto custom-scrollbar p-4 lg:p-8">
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4 lg:gap-6 pb-20 lg:pb-0">
        {filteredServices.map((service) => {
          const isLocked = service.isPro && !isPro;
          return (
            <div 
              key={service.id}
              className="group relative bg-white dark:bg-[#111115] rounded-[24px] p-5 border border-slate-200 dark:border-white/5 transition-all duration-300 hover:scale-[1.01] hover:shadow-xl cursor-pointer overflow-hidden flex flex-col"
              onClick={() => onSelectService(service)}
            >
              <div className={`absolute top-0 right-0 w-32 h-32 bg-gradient-to-br ${service.color} opacity-[0.03] group-hover:opacity-[0.08] rounded-bl-[100px] transition-opacity`}></div>
              
              <div className="flex justify-between items-start mb-4 relative z-10">
                   <div className={`w-12 h-12 rounded-2xl bg-gradient-to-br ${service.color} flex items-center justify-center text-white text-xl shadow-lg group-hover:scale-110 transition-transform`}>
                      <i className={`fas ${service.icon}`}></i>
                   </div>
                   <div className="flex gap-2 mt-1 mr-8"> 
                     {isLocked && <i className="fas fa-lock text-slate-300 dark:text-slate-600"></i>}
                     {service.isNew && !isLocked && <span className="bg-emerald-500/10 text-emerald-500 text-[9px] font-black px-2 py-1 rounded-md uppercase">{t.new}</span>}
                   </div>
              </div>
              
              <h3 className="text-base font-black text-slate-800 dark:text-white mb-1.5">{service.title}</h3>
              <p className="text-xs text-slate-500 dark:text-slate-400 font-medium leading-relaxed mb-4 line-clamp-2">{service.description}</p>

              <div className="pt-4 border-t border-slate-100 dark:border-white/5 flex gap-2">
                <button className="flex-1 py-2 bg-slate-50 dark:bg-white/5 rounded-lg text-[10px] font-bold text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-white/10 transition-colors">{t.serviceDetails}</button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default ServicesGrid;
